export default __webpack_public_path__ + "static/media/5.43fc0222.JPG";